export default {

    data() {
        return {
            filter: '',
            selected: [],
            showInfoModal: false,
        }
    },

    mounted() {
        this.selectedSource.forEach((el) => {
            let sourceElement = this.source.find(sourceEl => sourceEl.id == el.id)
            if(sourceElement)
                this.selected.push(sourceElement);
        })
    },

    props: {
        source: {
            type: Array,
            default: () => [],
            required: true,
        },

        selectedSource: {
            type: Array,
            default: () => [],
            required: false,
        },

        rules: {
            type: Object,
            default: () => {},
            required: false,
        },

        type : {
            type: String,
            default: 'user',
            required: false,
        },

        enableAdd : {
            type : Boolean,
            default: false,
            required: false,
        },

        enableSelect: {
            type: Boolean,
            default: true,
            required: false,
        },

        enableButton: {
            type: Boolean,
            default: true,
            require: false,
        },

        buttonText: {
            type: Function,
            default: () => { return 'Posicionar'},
            require: false,
        },

        buttonType : {
            type: Function,
            default: () => { return 'Posicionar'},
            require: false,
        }

    },

    methods: {
        toggleNew(){
            this.showInfoModal = true;
        },

        addElement(value) {
            this.$emit('addElement', value)
            this.showInfoModal = false;
        },
    },


    computed: {
        computedItems() {
            return this.source.filter(el => {
                return el.name.includes(this.filter)
            });
        },

        isAllChecked() {
            return this.computedItems.length == this.selected.length
        },

        isAddEnabled() {
            console.log(this.enableAdd)
            return this.enableAdd;
        }
    },

    watch: {
        selected: {
            deep: true, // Required to detect changes within the array
            handler(newVal) {
                console.log(newVal);
                this.$emit('itemsChanged', newVal); // Emit the updated array
            },
        },
    },
}
